export enum IconsEnum {
  EDIT = 'edit_button',
  CUSTOMER_DETAILS = 'customer_details',
  MESSAGES_DARK = 'messages_dark',
  SWAP_DRIVING_APPS = 'swap_driving_apps',
  TIME = 'time',
}
